<template>
  <div>
    <Ibox :titulo="'Filtros'">
      <FormGroup
          cols="4"
          label="Habilitado">
        <v-select
            v-model="filtro.habilitado"
            :clearable=false
            :options="[{v:'0',label:'Todo'},{v:'S',label:'Si'},{v:'N',label:'No'}]"
            :reduce="option=>option.v">
        </v-select>
      </FormGroup>
      <b-col cols="12" align="right">
        <b-button v-if="loading" variant="primary">
          <Loading :size="'1'" :text="'Cargando'"/>
        </b-button>
        <b-button v-else variant="primary" v-on:click="cargar">Cargar</b-button>
      </b-col>
    </Ibox>
    <Ibox :titulo="'Sucursales'">
      <b-col cols="12">
        <DataTable
            :loading="loading"
            :columns="columns"
            :rows="rows"
            clases="table-bordered table-hover table-condensed nowrap">
          <div slot="table-actions">
            <router-link
                v-if="utils.tienePermiso() && mostrarAgregar()"
                class="btn btn-primary btn-sm"
                tag="button"
                :to="{ name: 'sucursal/agregar' }">Agregar sucursal
            </router-link>
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'action' && utils.tienePermiso()">
              <span v-if="props.row.habilitado == 'S'">
                <router-link  :to="{ name: 'sucursal/empresas', params: { sucursal: utils.je64(props.row) } }">Empresas</router-link>
                |
                <router-link :to="{ name: 'sucursal/trabajadores', params: { sucursal: utils.je64(props.row) } }">Trabajadores</router-link>
                |
                <router-link :to="{ name: 'sucursal/vehiculos', params: { sucursal: utils.je64(props.row) } }">Vehiculos</router-link>
                <span v-if="mostrarUsuarios()"> 
                  |
                  <router-link  :to="{ name: 'sucursal/usuarios', params: { sucursal: utils.je64(props.row) } }">Usuarios</router-link>
                </span>
                |
              </span>
              <span v-if="mostrarEditar()">
                <router-link :to="{ name: 'sucursal/editar', params: { sucursal: utils.je64(props.row) } }">Editar</router-link>
              </span>
            </span>
            <span v-else-if="props.column.field == 'habilitado'">
              {{ descHabilitado(props.row) }}
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </DataTable>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import { sucursalService, userService, globales} from "@/services";
import { utils } from "@/helpers";

export default {
  name: "ConfigurarSucursales",
  data() {
    return {
      utils,
      filtro: {
        habilitado:'S'
      },
      loading:false,
      columns: [
        {label: 'Sucursal', field: 'desc_sucursal'},
        {label: 'Habilitado', field: 'habilitado'},
        {label: 'Accion', field: 'action'}
      ],
      rows: [],
    }
  },
  mounted() {
    this.cargar();
  },
  computed: {
  },
  methods: {
    mostrarAgregar(){
      return userService.getUser().perfiles.includes( globales.perfil.admin_cliente) || userService.getUser().perfiles.includes( globales.perfil.admin);
    },
    mostrarUsuarios(){
      return userService.getUser().perfiles.includes( globales.perfil.admin_cliente) || userService.getUser().perfiles.includes( globales.perfil.admin);
    },
    mostrarEditar(){
      return userService.getUser().perfiles.includes( globales.perfil.admin_cliente) || userService.getUser().perfiles.includes( globales.perfil.admin);
    },
    cargar() {
      this.loading = true;

      sucursalService.getSucursal({
        id_cliente: userService.getUser().id_cliente, 
        id_perfil: userService.getUser().perfiles,
        id_usuario: userService.getUser().id_usuario,
        habilitado: this.filtro.habilitado
      }).then(data => {
        this.rows = data.data;
        this.loading = false;
      });
    },
    descHabilitado(row){
      if(row.habilitado == 'S'){
        return 'Si';
      }else{
        return 'No';
      }
    }
  }
}
</script>

<style scoped>

</style>